import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import ContactsPage, {
  Props as ContactPageProps
} from "../components/contacts/ContactsPage";
import PageNotFoundError from "../lib/pageNotFoundError";
import PageProps from "../lib/models/pageProps";

export default function Contacts(props: ContactPageProps) {
  return <ContactsPage {...props} />;
}

Contacts.getInitialProps = async ({
  api,
  query
}: InitialPropsContext): PageProps<ContactPageProps> => {
  const { tab } = query;
  const [content, categoryCluster] = await Promise.all([
    api.loadContacts().catch(() => {
      throw new PageNotFoundError();
    }),
    api
      .listCategoryClusters({
        orderBy: "posit",
        fields: ["contacts", "name", "segment"]
      })
      .catch(() => ({ total: 0, items: [] }))
  ]);
  const segmentContacts: ContactPageProps["segmentContacts"] = {};

  categoryCluster.items.forEach(cc => {
    if (!cc.contacts.length) return;
    const n = cc.segment.name;

    if (!segmentContacts[n]) segmentContacts[n] = {};

    segmentContacts[n][cc.name] = cc.contacts.map(({ contact, role }) => ({
      ...contact,
      role
    }));
  });

  return {
    ...content,
    segmentContacts,
    activeTab: tab ? String(tab) : undefined
  };
};
